import { isHostedCalendar } from "owa-config";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function isTeamsManageCategoriesEnabled(): boolean {
    return isHostedCalendar() && isGlobalFeatureEnabled("cal-teams-manage-categories");
}
